import { render, staticRenderFns } from "./CancellationForm.vue?vue&type=template&id=6f5f46cd&scoped=true"
import script from "./CancellationForm.vue?vue&type=script&lang=js"
export * from "./CancellationForm.vue?vue&type=script&lang=js"
import style0 from "./CancellationForm.vue?vue&type=style&index=0&id=6f5f46cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f46cd",
  null
  
)

export default component.exports